module.exports = __webpack_public_path__ + "img/fa-brands-400.a9c4bb73.svg";